import React from 'react';
import {
    Create,
    SimpleForm,
    required,
    ReferenceField,
    TextField, AutocompleteInput, ReferenceInput,
} from 'react-admin';
import { redirectToReglaTab } from '../regla/regla-utils';
const redirectToReglaEditTransaccionesTab = (basePath, id, data) => redirectToReglaTab(data.idRegla, 'tipo-transaccion');

const ReglaTipoTransaccionCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect={redirectToReglaEditTransaccionesTab}>
            <ReferenceField
                source="idRegla"
                reference="regla"
                link={false}
            >
                <TextField source="descripcion" />
            </ReferenceField>
            <ReferenceInput
                source="idTipoTransaccion"
                reference="tipos-transaccion"
                label="resources.regla-tipo-transaccion.fields.idTipoTransaccion"
                sort={{ field: "descripcion", order: "ASC" }}
                perPage={100}
                filterToQuery={(searchText) => ({
                    descripcion: searchText ? searchText : "",
                })}
                validate={[required()]}
            >
                <AutocompleteInput optionText="descripcion" optionValue="id" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);

export default ReglaTipoTransaccionCreate;
